
import { Vue, Options, prop, } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

class Props {
  modelValue = prop<number>({
    type: Number,
    default: 0
  });
}

@Options({
  emits: ["followed"],
  components: { }
})

export default class FollowReport extends Vue.with(Props) {

  async followReport() {
    try {
      MainAppController.showLoading();
      await PusatResolusiV2Controller.followTicket(this.modelValue || Number(this.$route.params.id) as number);
      this.$emit("followed");
    } catch(error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error, 
          "Gagal Mengikuti !", 
          () => {
            MainAppController.closeErrorMessage();
            this.followReport();
          }
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
